<template>
  <div class="paper-choice-no-choice">
    <PaperWrap>
      <template #default="{paperBatchId}">
        <div class="cont-wrap">
          <template v-if="paperBatchId">
            <TemplateDataGrid :key="paperBatchId"
                            ref="grid"
                            gridId="PaperNoChoiceStudent"
                            v-bind="{paperBatchId}"></TemplateDataGrid>
          </template>
          <Hint v-else>请先选择论文批次</Hint>
        </div>
      </template>
    </PaperWrap>
  </div>
</template>

<script>
import Hint from '../../../../../../elements/Hint.vue'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import PaperWrap from '../../wrap'
export default {
  name: 'PaperChoiceNoChoice',
  components: {
    Hint,
    TemplateDataGrid,
    PaperWrap
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-no-choice{
  height: 100%;
  .cont-wrap{
    height: 100%;
  }
}
</style>
